<div class="card bg-white mb-3">
  <div class="d-flex align-items-center border-bottom px-2">
    <div class="d-flex flex-column w-100">

      <div class="d-flex flex-row flex-wrap align-items-center gap-2 w-100 py-2">
        <h2 class="h4 mb-0 me-3 location-title">Locations</h2>

        <!-- Mobile actions dropdown -->
        <div ngbDropdown placement="bottom-end" [autoClose]="'outside'"
          class="location-actions-dd d-lg-none ms-auto" *ngIf="canShowAdvancedActions()">
          <button type="button" ngbDropdownToggle class="location-actions-toggle" aria-label="Location actions">
            <i class="fas fa-ellipsis-v"></i>
          </button>
          <div ngbDropdownMenu class="location-actions-menu">
            <h6 class="dropdown-header">Location Actions</h6>
            <a *ngIf="user.canManage(tender)" (click)="addContract()" href="javascript:void(0)"
              class="dropdown-item d-flex align-items-center gap-2">
              <i class="fas fa-location-dot text-muted"></i> Add Location
            </a>
            <jft-extend-tender-all-rounds-button [tender]="tender" (onExtended)="onRoundExtend($event)"
              [class]="'dropdown-item d-flex align-items-center gap-2'">
            </jft-extend-tender-all-rounds-button>
            <jft-launch-next-round-all-locations-button [class]="'dropdown-item d-flex align-items-center gap-2'"
              (onUpdated)="onRoundLaunchedAllLocations($event)" [tender]="tender">
            </jft-launch-next-round-all-locations-button>
          </div>
        </div>
        <ul class="nav nav-links location-tabs me-3">
          <li class="nav-item">
            <a [routerLink]="['/tenders', tender.id, 'locations', 'all']" routerLinkActive="active"
              [routerLinkActiveOptions]="{exact: true}" class="nav-link">
              All
              <span class="badge rounded-pill bg-light text-dark border">{{stats.contractsTotal}}</span>
            </a>
          </li>
          <li class="nav-item">
            <a [routerLink]="['/tenders', tender.id, 'locations', 'awaiting-bids']" routerLinkActive="active"
              [routerLinkActiveOptions]="{exact: true}" class="nav-link">
              Awaiting Bids
              <span class="badge rounded-pill bg-light text-dark border">{{stats.contractsAwaitingBids}}</span>
            </a>
          </li>
          <li class="nav-item">
            <a [routerLink]="['/tenders', tender.id, 'locations', 'awaiting-review']" routerLinkActive="active"
              [routerLinkActiveOptions]="{exact: true}" class="nav-link">
              Awaiting Review
              <span class="badge rounded-pill bg-light text-dark border">{{stats.contractsAwaitingReview}}</span>
            </a>
          </li>
          <li class="nav-item">
            <a [routerLink]="['/tenders', tender.id, 'locations', 'cancelled']" routerLinkActive="active"
              [routerLinkActiveOptions]="{exact: true}" class="nav-link">
              Cancelled
              <span class="badge rounded-pill bg-light text-dark border">{{stats.contractsCancelled}}</span>
            </a>
          </li>
          <li class="nav-item">
            <a [routerLink]="['/tenders', tender.id, 'locations', 'expired']" routerLinkActive="active"
              [routerLinkActiveOptions]="{exact: true}" class="nav-link">
              Expired
              <span class="badge rounded-pill bg-light text-dark border">{{stats.contractsExpired}}</span>
            </a>
          </li>
          <li class="nav-item">
            <a [routerLink]="['/tenders', tender.id, 'locations', 'awarded']" routerLinkActive="active"
              [routerLinkActiveOptions]="{exact: true}" class="nav-link">
              Awarded
              <span class="badge rounded-pill bg-light text-dark border">{{stats.contractsAwarded}}</span>
            </a>
          </li>
        </ul>


        <div class="d-none d-lg-flex flex-wrap align-items-center gap-2 location-actions ms-lg-auto">
          <a *ngIf="canShowAdvancedActions() && user.canManage(tender)" (click)="addContract()" href="javascript:void(0)"
            class="btn btn-light">
            <span class="me-2">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                class="lucide lucide-map-pin-plus-icon lucide-map-pin-plus">
                <path
                  d="M19.914 11.105A7.298 7.298 0 0 0 20 10a8 8 0 0 0-16 0c0 4.993 5.539 10.193 7.399 11.799a1 1 0 0 0 1.202 0 32 32 0 0 0 .824-.738" />
                <circle cx="12" cy="10" r="3" />
                <path d="M16 18h6" />
                <path d="M19 15v6" />
              </svg>
            </span> Add Location
          </a>
          <jft-extend-tender-all-rounds-button *ngIf="canShowAdvancedActions()" [tender]="tender"
            (onExtended)="onRoundExtend($event)" [class]="'btn btn-light'">
          </jft-extend-tender-all-rounds-button>
          <jft-launch-next-round-all-locations-button *ngIf="canShowAdvancedActions()" [class]="'btn btn-light'"
            (onUpdated)="onRoundLaunchedAllLocations($event)" [tender]="tender">
          </jft-launch-next-round-all-locations-button>
        </div>
      </div>
      <!-- Mobile: toggle the search + filters -->
      <button type="button" class="location-filters-toggle d-lg-none w-100 border-top" (click)="filtersOpen = !filtersOpen"
        [attr.aria-expanded]="filtersOpen">
        <span><i class="fas fa-filter me-2 text-muted"></i>Search &amp; Filters</span>
        <i class="fas" [ngClass]="filtersOpen ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
      </button>
      <div class="d-flex flex-row flex-wrap align-items-center gap-2 w-100 border-top py-2 location-filter-bar"
        [class.open]="filtersOpen">
        <jft-tender-bids-search-bar class="location-search" (onChanges)="search($event)"></jft-tender-bids-search-bar>

        <!-- Filters Section -->
        <div class="d-flex flex-row flex-wrap align-items-center gap-2 ms-lg-auto location-filters" *ngIf="showFilters()">
          <!-- Round Filter -->
          <div class="filter-group" *ngIf="maxRound > 1">
            <ng-select [items]="roundOptions" [clearable]="false" bindLabel="label" bindValue="value"
              placeholder="Round..." [(ngModel)]="selectedRound"
              (ngModelChange)="onRoundFilterChange()" class="filter-select">
            </ng-select>
          </div>

          <!-- Company Filter -->
          <div class="filter-group" *ngIf="!tender.company.settings.isHiddenField('location_company')">
            <ng-select [items]="companyOptions" [multiple]="true" [clearable]="true" bindLabel="name" bindValue="value"
              placeholder="Filter by Company..." [(ngModel)]="selectedCompanies"
              (ngModelChange)="onCompanyFilterChange()" class="filter-select">
            </ng-select>
          </div>

          <!-- Fuel Type Filter -->
          <div class="filter-group" *ngIf="!tender.company.settings.isHiddenField('location_fuel_type')">
            <ng-select [items]="fuelTypeOptions" [multiple]="true" [clearable]="true" bindLabel="name" bindValue="id"
              placeholder="Filter by Fuel Type..." [(ngModel)]="selectedFuelTypes"
              (ngModelChange)="onFuelTypeFilterChange()" class="filter-select">
            </ng-select>
          </div>

          <!-- Flight Type Filter -->
          <div class="filter-group" *ngIf="!tender.company.settings.isHiddenField('location_flight_type')">
            <ng-select [items]="flightTypeOptions" [multiple]="true" [clearable]="true" bindLabel="name" bindValue="id"
              placeholder="Filter by Flight Type..." [(ngModel)]="selectedFlightTypes"
              (ngModelChange)="onFlightTypeFilterChange()" class="filter-select">
            </ng-select>
          </div>

          <!-- Supplier Company Filter -->
          <div class="filter-group">
            <ng-select [items]="supplierOptions" [multiple]="true" [clearable]="true" bindLabel="name" bindValue="id"
              placeholder="Filter by Supplier..." [(ngModel)]="selectedSuppliers"
              (ngModelChange)="onSupplierFilterChange()" class="filter-select">
            </ng-select>
          </div>

          <!-- Location Tags Filter -->
          <div class="filter-group" *ngIf="locationTagOptions.length > 0">
            <ng-select [items]="locationTagOptions" [multiple]="true" [clearable]="true" bindLabel="name" bindValue="id"
              placeholder="Filter by Location Tags..." [(ngModel)]="selectedLocationTags"
              (ngModelChange)="onLocationTagFilterChange()" class="filter-select">
            </ng-select>
          </div>
        </div>
      </div>
    </div>


  </div>

  <router-outlet></router-outlet>

</div>